export const TaskStatus = {
  INCOMPLETE: 'INCOMPLETE',
  COMPLETE: 'COMPLETE',
  SKIPPED: 'SKIPPED',
};
